"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSigningModifiedError = void 0;
var DomainSigningModifiedError = /** @class */ (function (_super) {
    __extends(DomainSigningModifiedError, _super);
    function DomainSigningModifiedError() {
        var _this = _super.call(this, "Domain signer returned a transaction that differs from the original challenge. Only the client_domain signature should be added — the operations, source account, sequence number, memo and network passphrase must all be left unchanged.") || this;
        _this.name = "DomainSigningModifiedError";
        Object.setPrototypeOf(_this, DomainSigningModifiedError.prototype);
        return _this;
    }
    return DomainSigningModifiedError;
}(Error));
exports.DomainSigningModifiedError = DomainSigningModifiedError;
